export default __webpack_public_path__ + "static/media/warehouse2.546389f8.png";